module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scrollable-link relative padding-left-sm-2 padding-right-sm-2 scroll-root padding-left-xs-0 padding-right-xs-0 margin-top-sm-h margin-bottom-sm-h margin-top-xs-h margin-bottom-xs-h"
  }, [_c('div', {
    staticClass: "absolute scroll left hidden-xs"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.scrollLeft($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.cdnImage('/img/ui/left_caret.svg'),
      "width": "100%"
    }
  })])]), _c('div', {
    staticClass: "absolute scroll right hidden-xs"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.scrollRight($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.cdnImage('/img/ui/right_caret.svg'),
      "width": "100%"
    }
  })])]), _c('ul', {
    ref: "scroller",
    staticClass: "reset-list",
    on: {
      "scroll": _vm.checkScrollerVisibility
    }
  }, _vm._l((_vm.slideConfig), function(slide) {
    return _c('li', {
      staticClass: "padding-left-sm-h padding-right-sm-h",
      class: ("per-row-" + _vm.itemsPerPage),
      style: ({
        width: _vm.getWidth()
      })
    }, [_c('a', {
      attrs: {
        "href": _vm.getSlideUrl(slide.url) || '#',
        "target": _vm.linkTarget || false
      }
    }, [(_vm.imageLazyLoading === 'Yes') ? _c('div', {
      staticClass: "slide-background b-lazy",
      style: ({
        'padding-bottom': _vm.getPadding()
      }),
      attrs: {
        "data-src": _vm.getBackgroundSrc(slide)
      }
    }) : _vm._e(), (_vm.imageLazyLoading !== 'Yes') ? _c('div', {
      staticClass: "slide-background",
      style: ({
        'background-image': _vm.getBackground(slide),
        'padding-bottom': _vm.getPadding()
      })
    }) : _vm._e(), (slide.title) ? _c('h3', {
      staticClass: "margin-top-sm-h margin-top-xs-h"
    }, [_vm._v(_vm._s(slide.title))]) : _vm._e(), (slide.text) ? _c('p', [_vm._v(_vm._s(slide.text))]) : _vm._e()])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-143b61fb"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CMSScrollableLink.vue
// module id = 283
// module chunks = 15